import React, { useState, useEffect, useCallback, useMemo  } from 'react';
import "./ProudctsList.css"
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom"; 
import './ProudctsList.css';
import { Container } from 'react-bootstrap';
import { SideBar, Products } from '../../Features/ProudctsList';
import {
    ListItem,
    ListItemText,
} from '@mui/material';
import axios from "axios";
import { toast } from 'react-toastify';
import no_image from "../../assets/Images/no-image.png"

const ProudctsList = ({ url, data }) => {
    const [activeSidebar, setActiveSidebar] = useState(false);
    const [tree, setTree] = useState({});
    const [brandData, setBrandData] = useState([]);
    const [brandSelected, setBrandSelected] = useState([]);
    const location = useLocation();
    const [compareList, setCompareList] = useState([]);
    const [isVisible, setIsVisible] = useState(false);
    const [isFirstOpen, setIsFirstOpen] = useState(false);
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(true);
    const [filtersData, setData] = useState([]);
    const [selectedItems, setSelectedItems] = useState({});
    const [hashmapSpecifications, setHashmapSpecifications] = useState({});


    useEffect(() => {
        if (compareList.length > 0) {
            setIsVisible(true);
            if (compareList.length === 1) {
                setIsFirstOpen(true);
            }
        } else if (isVisible) {
            setTimeout(() => setIsVisible(false), 10);
        }
    }, [compareList]);

    const handleRemoveItem = (name) => {
        setCompareList((prev) => prev.filter((item) => item.name !== name));
    };

    const handleSidebar = useCallback(() => {
        setActiveSidebar(prev => !prev);
      }, []);
      

    const handleCompare = () => {
        // navigate('/CompareDevices', { state: { compareList } });
        // omarg
        // removed state and used localstorage instead
        localStorage.setItem("compareList", JSON.stringify(compareList));
        navigate('/CompareDevices');
    };


    useEffect(() => {
        if (filtersData.length == 0) {
            fetchFilters()
        }
    }, [])
    


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const brand = params.get("brand");
        if (brand) {
          setBrandSelected([brand]); 
        }
      }, [location.search]);

    function extractSpecifications(data, result = {}) {
    for (const [key, value] of Object.entries(data)) {
        if (typeof value === 'object' && value !== null) {
            if (value.is_group === 0) {
                result[key] = value;
            } else {
                extractSpecifications(value, result);
            }
        }
    }
    return result;
    }

    
    const fetchFilters = async () => {
        setLoading(true);
        try {
            let apiUrl = `${url}/api/method/webshop.webshop.doctype.specification.specification.specification?item_group=Tracking Devices`;
            const response = await axios.get(apiUrl, {
                headers: {
                    "Content-Type": "application/json",
                }
            });
            if (response.data.status_code !== 200) {
                toast.error("Failed to fetch filters. Please try again..");
            }
            const result = response.data.result;
            setData(result);
            let _temp = extractSpecifications(response.data.result.specifications);

            // Merge new values while keeping previous ones
            let updatedTemp = { ..._temp, ...extractSpecifications(response.data.result.features) };
  
            
            setHashmapSpecifications(updatedTemp);
            setLoading(false);
        } catch (error) {
            toast.error("Failed to fetch filters. Please try again..");
            setLoading(false);
        }
    };


    const addNode = (tree, path, nodeData) => {
        let current = tree;
        path.forEach((item, index) => {
          const key = item.key;
          if (index === path.length - 1) {
            current[key] = nodeData;
          } else {
            if (!current[key]) {
              current[key] = {
                is_group: hashmapSpecifications[key]?.is_group ?? 1
              };
            }
            current = current[key];
          }
        });
      };
      
      const updateNode = (tree, path, nodeData, nodeName) => {
        let current = tree;
        for (let i = 0; i < path.length; i++) {
          const key = path[i].key;
          if (!current[key]) {
        
            current[key] = {
              is_group: hashmapSpecifications[key]?.is_group ?? 1
            };
          }
      
          if (i === path.length - 1 && key === nodeName) {
            current[key] = nodeData;
          } else {
            current = current[key];
          }
        }
      };
      
      const removeNode = (tree, path) => {
        let current = tree;
        
        // Delete the target node
        for (let i = 0; i < path.length - 1; i++) {
          current = current[path[i].key];
        }
        delete current[path[path.length - 1].key];
      
        // Clean up empty parent groups
        let cleanupPath = [...path];
        while (cleanupPath.length > 0) {
          let pointer = tree;
          const currentPath = cleanupPath.slice(0, -1);
          
          // Traverse to current level
          for (const { key } of currentPath) {
            pointer = pointer[key];
          }
          
          const lastKey = cleanupPath[cleanupPath.length - 1].key;
          
          // Check if node is empty group
          if (pointer[lastKey]?.is_group === 1) {
            const children = Object.keys(pointer[lastKey]).filter(k => k !== 'is_group');
            
            if (children.length === 0) {
              delete pointer[lastKey];
              cleanupPath.pop();
            } else {
              break;
            }
          } else {
            break;
          }
        }
      };


      useEffect(() => {
        const params = new URLSearchParams(location.search);
        
        if (brandSelected.length > 0) {
          params.set('brand', brandSelected[0]);
        } else {
          params.delete('brand');
        }
      
        // Update URL without page reload
        navigate(`?${params.toString()}`, { replace: true });
      }, [brandSelected, navigate, location.search]);
      

    return (
        <>
            <div className='products-list'>
                <div className={`sidebar-responsive-container ${activeSidebar ? 'active' : ''}`}>
                    <div className='sidebar-responsive-overlay' onClick={handleSidebar}></div>
                    <div className='sidebar-responsive'>
                        <SideBar 
                            handleSidebar={handleSidebar} 
                            url={url} 
                            tree={tree} 
                            setTree={setTree}
                            brandData= {brandData}
                            setBrandData={setBrandData}
                            brandSelected ={brandSelected}
                            setBrandSelected={setBrandSelected}
                            searchQuery={searchQuery}
                            setSearchQuery={setSearchQuery}
                            loading={loading}
                            filtersData={filtersData}
                            addNode={addNode}
                            updateNode={updateNode}
                            removeNode={removeNode}
                            selectedItems={selectedItems}
                            setSelectedItems={setSelectedItems}

                        />
                    </div>
                </div>

                <Container>
                    <div className='products-list-container'>
                        <div className='products-list-sidebar-container'>
                            <SideBar 
                                handleSidebar={handleSidebar} 
                                url={url} 
                                tree={tree} 
                                setTree={setTree}
                                brandData= {brandData}
                                setBrandData={setBrandData}
                                brandSelected ={brandSelected}
                                setBrandSelected={setBrandSelected}
                                searchQuery={searchQuery}
                                setSearchQuery={setSearchQuery}
                                loading={loading}
                                filtersData={filtersData}
                                addNode={addNode}
                                updateNode={updateNode}
                                removeNode={removeNode}
                                selectedItems={selectedItems}
                                setSelectedItems={setSelectedItems}
                            />
                        </div>
                        <div className='products-list-content'>
                            <Products
                                url={url}
                                handleSidebar={handleSidebar}
                                tree={tree}
                                data={data}
                                compareList={compareList}
                                setCompareList={setCompareList}
                                removeFromList={handleRemoveItem}
                                searchQuery={searchQuery}
                                brandSelected={brandSelected}
                                brandData= {brandData}
                                filtersData={filtersData}
                                addNode={addNode}
                                updateNode={updateNode}
                                removeNode={removeNode}
                                setTree={setTree}
                                selectedItems={selectedItems}
                                setSelectedItems={setSelectedItems}
                                filtersLoading={loading}
                            />
                        </div>
                    </div>
                </Container>
            </div>

            {isVisible && (
                <div className={`compare-items-container ${isFirstOpen ? 'slide-up' : 'slide-down'}`}>
                    <Container>
                        <div className='content'>
                            <div className='content-text'>
                                <div className='text'>Compare</div>
                                <div className='text1'>Up to 4 products</div>
                            </div>

                            <div className='compare-row'>
                                {compareList.map((selectedDevice, index) => (
                                    <ListItem
                                        className={`compare-item-card`}
                                        key={selectedDevice.name}
                                    >
                                        {selectedDevice.image != null ? (
                                            <img
                                                className="list-option-image"
                                                src={url + '/' + selectedDevice.image}
                                                alt={selectedDevice.website_name}
                                            />
                                        ) : (
                                            <img
                                                className="list-option-image null-image"
                                                src={no_image}
                                                alt={selectedDevice.website_name}
                                            />
                                        )}
                                        <ListItemText
                                            className='text'
                                            primary={
                                                <span className="website-item-text" title={selectedDevice.website_name}>
                                                    {selectedDevice.website_name.length > 15
                                                        ? `${selectedDevice.website_name.slice(0, 15)}...`
                                                        : selectedDevice.website_name}
                                                </span>
                                            }
                                        />
                                        <div onClick={() => handleRemoveItem(selectedDevice.name)} className='unselect-device-icon'>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="15"
                                                height="14"
                                                viewBox="0 0 15 14"
                                                fill="none"
                                            >
                                                <path
                                                    d="M1 1L14 13M1 13L14 1"
                                                    stroke="#B5B5B5"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </div>
                                    </ListItem>
                                ))}
                            </div>

                            <button
                                className="compare-btn"
                                style={{ 
                                    cursor: compareList.length >= 2 ? 'pointer' : 'not-allowed',
                                    opacity: compareList.length >= 2 ? 1 : 0.6
                                }}
                                onClick={handleCompare}
                                disabled={compareList.length < 2}
                            >
                                COMPARE NOW
                            </button>
                        </div>
                    </Container>
                </div>
            )}
        </>
    );
};

export default ProudctsList;
